import { useForm } from "react-hook-form"
import { prescriptionSchema } from "../schema"
import { PrescriptionType } from "../types"
import { zodResolver } from "@hookform/resolvers/zod"
import { useCreatePrescriptionMutation } from "../api/mutations"
// import usePatientStore from "../store/patient-store"
import { toast } from "sonner"

export const usePrescription = (encounterId: string, refillId?: string, prescriptionId?: string, onClose?: () => void) => {
    // const selectedPatient = usePatientStore(state => state.selectedPatient);

    const form = useForm<PrescriptionType>({
        defaultValues: {
            medication: "", 
            dosage: "",
            duration: "",
            cost: 0,
            note: "",
            refills: 0,
            vitamin: {
                name: ""
            },
            substitute: false,
            reason: "",
            // patient_id: selectedPatient?.user_id || ""
        },
        resolver: zodResolver(prescriptionSchema)
    })

    const {mutateAsync: createPrescriptionMutation, isPending} = useCreatePrescriptionMutation(encounterId);

    const handleSubmit = async (data: PrescriptionType) => {
        // if (!selectedPatient?.user_id || !data?.patient_id) return;

        const payload = {
            // patient_id: data.patient_id || selectedPatient.user_id,
            type: "medication_payment",
            medications: [
                {
                    name: data.medication,
                    dosage: data.dosage,
                    quantity: 1,
                    duration: data.duration,
                    cost: data.cost,
                    vitamin: data.vitamin?.name?.trim() === "" ? null : { name: data?.vitamin?.name },
                    instructions: data.note,
                    refills: data.refills
                }
            ],
            note: data.note,
            substitute: data.substitute || false,
            reason: data.reason || "",
            program: 'weight_loss',
            refill_id: refillId || "",
            previous_prescription_id: prescriptionId || "",
        };
        
        try {
            await createPrescriptionMutation(payload);
            toast.success("Prescription added successfully");
            onClose?.();
        } catch (error) {
            toast.error("Failed to add prescription");
        }
    }

    return {
        form,
        handleSubmit,
        createPrescriptionMutation,
        isPending
    }
}